import NotFound from '@/components/NotFound';
import Layout from '@/Layouts';
import Index from '@/pages/index';
import Login from '@/pages/login';
import ProjectManage from '@/pages/projectManage';
import Combo from '@/pages/combo';
import IndustryManage from '@/pages/industryManage';
import Journalism from '@/pages/Journalism';
import addJournalism from '@/pages/addJournalism';
import lookJournalism from '@/pages/lookJournalism';

import { IRouterConfig } from 'ice';
import Loadable from 'react-loadable';

const Loading = () => 'loading';
const routerConfig: IRouterConfig[] = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/',
    // exact: true,
    component: Layout,
    children: [
      {
        path: '/index',
        component: Index,
      },
      {
        path: '/projectManage',
        component: ProjectManage,
      },
      {
        path: '/project-info/info',
        component: Loadable({
          loader: () => import('./pages/project-info/info'),
          loading: Loading,
        }),
      },
      {
        path: '/project-info/import',
        component: Loadable({
          loader: () => import('./pages/project-info/import'),
          loading: Loading,
        }),
      },
      {
        path: '/project-sync',
        component: Loadable({
          loader: () => import('./pages/project-sync'),
          loading: Loading,
        }),
      },
      {
        path: '/system/message',
        component: Loadable({
          loader: () => import('./pages/system/message'),
          loading: Loading,
        }),
      },
      {
        path: '/Journalism',
        component: Journalism,
      },
      {
        path: '/addJournalism',
        component: addJournalism,
      },
      {
        path: '/lookJournalism',
        component: lookJournalism,
      },
      {
        path: '/combo',
        component: Combo,
      },
      {
        path: '/industryManage',
        component: IndustryManage,
      },
      {
        path: '/system/cacheClear',
        component: Loadable({
          loader: () => import('./pages/system/cacheClear'),
          loading: Loading,
        }),
      }, {
        path: '/system/group',
        component: Loadable({
          loader: () => import('./pages/system/group'),
          loading: Loading,
        }),
      }, {
        path: '/system/limit',
        component: Loadable({
          loader: () => import('./pages/system/limit'),
          loading: Loading,
        }),
      }, {
        path: '/system/organizationAuthority',
        component: Loadable({
          loader: () => import('./pages/system/organizationAuthority'),
          loading: Loading,
        }),
      }, {
        path: '/system/personnelApproval',
        component: Loadable({
          loader: () => import('./pages/system/personnelApproval'),
          loading: Loading,
        }),
      }, {
        path: '/system/role',
        component: Loadable({
          loader: () => import('./pages/system/role'),
          loading: Loading,
        }),
      }, {
        path: '/system/pageManager',
        component: Loadable({
          loader: () => import('./pages/system/pageManager'),
          loading: Loading,
        }),
      }, {
        path: '/system/equipManager',
        component: Loadable({
          loader: () => import('./pages/system/equipManager'),
          loading: Loading,
        }),
      }, {
        path: '/system/rolePermissionGroup',
        component: Loadable({
          loader: () => import('./pages/system/rolePermissionGroup'),
          loading: Loading,
        }),
      }, {
        path: '/system/roleTemplate',
        component: Loadable({
          loader: () => import('./pages/system/roleTemplate'),
          loading: Loading,
        }),
      }, {
        path: '/system/user',
        component: Loadable({
          loader: () => import('./pages/system/user'),
          loading: Loading,
        }),
      },
      {
        path: '/system/config',
        component: Loadable({
          loader: () => import('./pages/system/config'),
          loading: Loading,
        }),
      },
      {
        path: '/gateway',
        component: Loadable({
          loader: () => import('./pages/gateway'),
          loading: Loading,
        }),
      },
      {
        path: '/officialWebsite/successfulCase',
        component: Loadable({
          loader: () => import('./pages/officialWebsite/successfulCase'),
          loading: Loading,
        }),
      },
      {
        path: '/officialWebsite/bannerManage',
        component: Loadable({
          loader: () => import('./pages/officialWebsite/bannerManage'),
          loading: Loading,
        }),
      },
      {
        path: '/officialWebsite/consumerMaintenance',
        component: Loadable({
          loader: () => import('./pages/officialWebsite/consumerMaintenance'),
          loading: Loading,
        }),
      },
      {
        path: '/officialWebsite/newsMaintenance',
        component: Loadable({
          loader: () => import('./pages/officialWebsite/newsMaintenance'),
          loading: Loading,
        }),
      },
      {
        path: '/officialWebsite/newsAddOrEdit',
        component: Loadable({
          loader: () => import('./pages/officialWebsite/newsAddOrEdit'),
          loading: Loading,
        }),
      },
      {
        path: '/firmManage',
        component: Loadable({
          loader: () => import('./pages/firmManage'),
          loading: Loading,
        }),
      },
      {
        path: '/eventsType',
        component: Loadable({
          loader: () => import('./pages/eventsType'),
          loading: Loading,
        }),
      },
      {
        path: '/commodityCenter/commodityClassification',
        component: Loadable({
          loader: () => import('./pages/commodityCenter/commodityClassification'),
          loading: Loading,
        }),
      },
      {
        path: '/commodityCenter/commodityClassificationSon',
        component: Loadable({
          loader: () => import('./pages/commodityCenter/commodityClassificationSon'),
          loading: Loading,
        }),
      },
      {
        path: '/commodityCenter/business',
        component: Loadable({
          loader: () => import('./pages/commodityCenter/business'),
          loading: Loading,
        }),
      },
      {
        path: '/commodityCenter/advertisement',
        component: Loadable({
          loader: () => import('./pages/commodityCenter/advertisement'),
          loading: Loading,
        }),
      },
      {
        path: '/user/findPassword',
        component: Loadable({
          loader: () => import('./pages/user/findPassword'),
          loading: Loading,
        }),
      },
      {
        path: '/user/userProfile',
        component: Loadable({
          loader: () => import('./pages/user/userProfile'),
          loading: Loading,
        }),
      },
      {
        path: '/paymentAccount',
        component: Loadable({
          loader: () => import('./pages/paymentAccount'),
          loading: Loading,
        }),
      },
      {
        path: '/systemMaintenance',
        component: Loadable({
          loading: Loading,
          loader: () => import('./pages/systemMaintenance'),
        }),
      },
      {
        // 404 没有匹配到的路由
        component: NotFound,
      },
      // {
      //   path: '/',
      //   redirect: '/platform',
      // },
    ],
  },
];

export default routerConfig;
